import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { IssuePerDayCount } from '../../models/issueItem';

interface IssuesHistogramProps {
  perDayCounts: IssuePerDayCount[];
}

const IssuePerDayHistogramRechart = ({ perDayCounts }: IssuesHistogramProps) => {
  return (
    <div className="w-full h-[600px] mt-4">
      <ResponsiveContainer width="100%" height="80%">
        <BarChart data={perDayCounts} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis
            dataKey="date"
            angle={-45}
            textAnchor="end"
            height={100}
            style={{ fill: 'var(--text-color)' }} 
          />
          <YAxis
            style={{ fill: 'var(--text-color)' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--text-color)',
              border: 'none',
              borderRadius: '8px',
              color: 'var(--secondary-color)',
            }}
          />
          <Bar dataKey="count" fill="var(--secondary-color)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default IssuePerDayHistogramRechart;
